var DetailMap = (function(){
    'use strict';

    var mapGL = null;
    var container = "detailMap";
    var layers = [];

    var init = function(lat, lng, title) {
        if($(container)){
            if (!maplibregl.supported()) {
              $(container).find('.maplibregl-unsupported').removeClass('is-hidden');
            } else {
              let zoom = 17;
              let minZoom = 10;
              let center =  [lng, lat];
              let style = styleLayerMap;
              let controls = {};

              controls = {
                navigation: {enable: 1, position: 'bottom-right'},
                geolocate: {enable: 0, position: 'bottom-right'}
              };

              mapGL = new MapGL(container, zoom, minZoom, center, style, controls);
              var mapObject = mapGL.getMapObject();

              mapObject.on('load', function() {

                this.addSource('single', {
                    'type': 'geojson',
                    'data': {
                        'type': 'FeatureCollection',
                        'features': [
                            {
                                'type': 'Feature',
                                'properties': {
                                    'nom': title,
                                },
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [lng, lat]
                                }
                            },
                        ]
                    }
                });

                this.addLayer({
                    'id': 'poi',
                    'type': 'symbol',
                    'source': 'single',
                    'layout': {
                      'icon-image': "poi-offre"
                    }
                });

                //mise à jour du aria-label du canvas
                $('.maplibregl-canvas').attr('aria-label', 'Localisation de l\'offre ' + title);
              });
            }
        }
    };

return {
    init: init
    };

}());
